import { Button } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import './NavBar.css';

const Logout = () => {
  const { logout } = useAuth();

  return (
    <Button color="inherit" className="logout-text" onClick={logout}>
      Cerrar Sesión
    </Button>
  );
}

export default Logout;
